// removed by extract-text-webpack-plugin
module.exports = {"smallDeviceMax":"567px","mediumDeviceMin":"568px","mediumDeviceMax":"991px","largeDeviceMin":"992px","large_device_min_alt":"1350px","imageTextCard":"src-components-elements-ImageTextCard-__ImageTextCard-module___imageTextCard","imageTextCardImage":"src-components-elements-ImageTextCard-__ImageTextCard-module___imageTextCardImage","imageTextCardContent":"src-components-elements-ImageTextCard-__ImageTextCard-module___imageTextCardContent","imageTextCardBody":"src-components-elements-ImageTextCard-__ImageTextCard-module___imageTextCardBody"};


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/ImageTextCard/ImageTextCard.module.css
// module id = 1021
// module chunks = 1